import {
  type D2CSiteBusinessProfile,
  type D2CSiteContactProfile,
  type D2CSiteImageList,
} from '@orcar/common';

// 회사가 ERP 자사몰관리 > 사이트 내용에서 고치는 값. 서버에 처음 넣은 값과 같고,
// 내용 API 응답 전이나 실패했을 때만 쓴다. 바꿀 때는 ERP에서 게시한다.
export const BUSINESS_PROFILE_FALLBACK: D2CSiteBusinessProfile = {
  tradeName: '(주)패밀리렌트카',
  representative: '이동우',
  registrationNumber: '316-88-00617',
  mailOrderNumber: '제 2019-제주도두-0023 호',
  address: '제주특별자치도 제주시 제성1길 67 (도두일동)',
  privacyOfficer: '이동우',
  phone: '064-746-5678',
  fax: '064-748-7722',
  bankAccount: '농협 301-0316-3267-11 패밀리렌트카',
  copyright: 'Copyright © 2017 www.familyrentacar.co.kr All Rights Reserved.',
};

export const CONTACT_PROFILE_FALLBACK: D2CSiteContactProfile = {
  csPhone: '064-746-5678',
  csHours: '매일 08시 ~ 19시',
  breakTime: '12시 ~ 13시',
  kakaoChannelUrl: 'https://pf.kakao.com/_JxgxbgT/chat',
};

// 홈 첫 화면 이미지·문구, 배너, 팝업. 내용 API가 실패했을 때만 쓴다.
// 문구에서 **로 감싼 부분은 굵게 보인다.
export const HOME_HERO_FALLBACK: D2CSiteImageList = {
  headline: '차량 1,000대 이상 보유!',
  headlineLine2: '**패밀리렌트카** 입니다',
  items: [
    {
      id: 'home_main',
      image: '/assets/home/img_family_home_bg.avif',
      mobileImage: '/assets/home/img_bg-mobile.avif',
      alt: '패밀리렌트카 홈 메인 이미지',
      startAt: '',
      endAt: '',
      visible: true,
    },
  ],
};

export const HOME_BANNERS_FALLBACK: D2CSiteImageList = {
  sectionTitle: '패밀리 이벤트 안내',
  items: [
    {
      id: 'home_renewal_banner',
      image: '/assets/home/img_home-banner-family.svg',
      mobileImage: '/assets/home/img_home-banner-mobile.svg',
      alt: '패밀리렌트카 홈 리뉴얼 안내 배너',
      link: '',
      startAt: '',
      endAt: '',
      visible: true,
    },
  ],
};

export const HOME_POPUP_FALLBACK: D2CSiteImageList = { items: [] };
